const API_CONFIG = {
  // Domain
  apiUrl: process.env.REACT_APP_API_URL + "/api",

  // User Manager API List
  userManager: {
    login: "/user-manager/login",
    loginRefresh: "/user-manager/login/refresh",
    logout: "/user-manager/logout",
    getAllUser: "/user-manager/users/systems/all",
    searchCompany: "/user-manager/companies/search",
    getCompany: (company_uuid) => `/user-manager/companies/${company_uuid}`,
    editCompany: (company_uuid) => `/user-manager/companies/edit/${company_uuid}`,
    getCompanyNews: (company_uuid) => `/user-manager/news/company_news/${company_uuid}`,
    searchCompanyNews: "/user-manager/news/search",
    updateNewsFileContent: (file_uuid) => `/user-manager/news/file/update-content/${file_uuid}`,
  },

  // 契約連絡者管理
  companyContact: {
    create: "/user-manager/company-contact/",
    edit: (company_contact_uuid) => `/user-manager/company-contact/edit/${company_contact_uuid}`,
    delete: (company_contact_uuid) => `/user-manager/company-contact/delete/${company_contact_uuid}`,
    search: "/user-manager/company-contact/search",
    info: (company_contact_uuid) => `/user-manager/company-contact/info/${company_contact_uuid}`,
  },

  // File Manager API List
  fileManager: {
    deletePermanent: (company_uuid) => `/file-manager/files/delete-permanent/${company_uuid}`,
    dowloadMulti: (company_uuid) => `/file-manager/files/download/multi/${company_uuid}`,
    newDowloadMulti: (company_uuid) => `/file-manager/files/new/download/multi/${company_uuid}`,
    deleteRecycleBin: (company_uuid) => `/file-manager/folders/delete-permanent/${company_uuid}`,
    getInfoFile: (company_uuid, file_uuid) => `/file-manager/files/thumbnails/${company_uuid}/${file_uuid}`,
    postOrgsInfo: (company_uuid, file_uuid) => `/file-manager/files/orgs/${company_uuid}/${file_uuid}`,
    getInfoFileRaw: (company_uuid, file_uuid) => `/file-manager/files/info/${company_uuid}/${file_uuid}`,
    celeryTaskStatus: (company_uuid) => `/file-manager/files/celery-task/status/${company_uuid}`,
    bukkenInfoEnv: (company_uuid, bukken_uuid) => `/file-manager/env/bukken-info/${company_uuid}/${bukken_uuid}`,
    getOrgDrawing: (company_uuid, folder_uuid) => `/file-manager/files/get/drawing/${company_uuid}/${folder_uuid}`
  },

  // 資格管理
  certificationMst: {
    create: (company_uuid) => `/company-manager/certification-mst/${company_uuid}`,
    info: (company_uuid, certification_uuid) => `/company-manager/certification-mst/info/${company_uuid}/${certification_uuid}`,
    edit: (company_uuid, certification_uuid) => `/company-manager/certification-mst/edit/${company_uuid}/${certification_uuid}`,
    search: (company_uuid) => `/company-manager/certification-mst/search/${company_uuid}`,
    delete: (company_uuid, certification_uuid) => `/company-manager/certification-mst/delete/${company_uuid}/${certification_uuid}`,
    recover: (company_uuid, certification_uuid) => `/company-manager/certification-mst/recover/${company_uuid}/${certification_uuid}`,
  },
  // 資格管理
  systemCertificationMst: {
    search: (company_uuid) => `/company-manager/certification-mst/system/search/${company_uuid}`,
  },

  // 社員資格管理
  employeeCertification: {
    create: (company_uuid) => `/company-manager/employee-certification/${company_uuid}`,
    info: (company_uuid, employee_certification_uuid) => `/company-manager/employee-certification/info/${company_uuid}/${employee_certification_uuid}`,
    edit: (company_uuid, employee_certification_uuid) => `/company-manager/employee-certification/edit/${company_uuid}/${employee_certification_uuid}`,
    search: (company_uuid) => `/company-manager/employee-certification/search/${company_uuid}`,
    delete: (company_uuid, employee_certification_uuid) => `/company-manager/employee-certification/delete/${company_uuid}/${employee_certification_uuid}`,
    recover: (company_uuid, employee_certification_uuid) => `/company-manager/employee-certification/recover/${company_uuid}/${employee_certification_uuid}`,
  },
  // 得意先社員資格管理
  customerEmployeeCertification: {
    create: (company_uuid) => `/company-manager/customer-employee-certification/${company_uuid}`,
    info: (company_uuid, employee_certification_uuid) => `/company-manager/customer-employee-certification/info/${company_uuid}/${employee_certification_uuid}`,
    edit: (company_uuid, employee_certification_uuid) => `/company-manager/customer-employee-certification/edit/${company_uuid}/${employee_certification_uuid}`,
    search: (company_uuid) => `/company-manager/customer-employee-certification/search/${company_uuid}`,
    delete: (company_uuid, employee_certification_uuid) => `/company-manager/customer-employee-certification/delete/${company_uuid}/${employee_certification_uuid}`,
    recover: (company_uuid, employee_certification_uuid) => `/company-manager/customer-employee-certification/recover/${company_uuid}/${employee_certification_uuid}`,
  },

  // 環境変数の取得
  // - 会社の環境変数
  compamyEnv: {
    search: (comapny_uuid) => `/file-manager/env/company-info/${comapny_uuid}`,
    create: (comapny_uuid) => `/file-manager/env/${comapny_uuid}`,
    multicreate: (comapny_uuid) => `/file-manager/env/update/multi/${comapny_uuid}`,
    getAutoNumConf: (comapny_uuid) => `/file-manager/env/number/info/${comapny_uuid}`,
    validAutonNum: (comapny_uuid) => `/file-manager/env/number/before_register/check/${comapny_uuid}`,
    portalContentOrder: (comapny_uuid) => `/andescloud/env/portal-content-order/${comapny_uuid}`,
  },

  // File S3 Manager API List
  fileS3Manager: {
    stepCreateFile: (company_uuid) => `/file-manager/files/new/step1/create/${company_uuid}`,
    stepUpdateFile: (company_uuid, file_uuid) => `/file-manager/files/new/step1/update/${company_uuid}/${file_uuid}`,
    stepUpdateContentFiles: (company_uuid, file_uuid) =>
      `/file-manager/files/new/step2/update-content/${company_uuid}/${file_uuid}`
  },

  // File S3 Manager API List
  fileS3Manager: {
    stepCreateFile: (company_uuid) => `/file-manager/files/new/step1/create/${company_uuid}`,
    stepUpdateFile: (company_uuid, file_uuid) => `/file-manager/files/new/step1/update/${company_uuid}/${file_uuid}`,
    stepUpdateContentFiles: (company_uuid, file_uuid) =>
      `/file-manager/files/new/step2/update-content/${company_uuid}/${file_uuid}`
  },

  // Folder Manager API List
  folderManager: {
    getChildren: (company_uuid) => `/file-manager/folders/children/${company_uuid}`,
    deletePermanent: (company_uuid) => `/file-manager/folders/delete-permanent/${company_uuid}`,
    download: (company_uuid, folder_uuid) => `/file-manager/folders/download/${company_uuid}/${folder_uuid}`,
    getFolderChildren: (company_uuid) => `/file-manager/folders/children/${company_uuid}`,

    getThumbnails: (company_uuid) => `/file-manager/files/thumbnails/multi/${company_uuid}`,

    getUrls: (company_uuid) => `/file-manager/files/url/${company_uuid}`,

    downloadFile: (company_uuid, file_uuid) => `/file-manager/files/raw/${company_uuid}/${file_uuid}`,

    downloadFolder: (company_uuid, folder_uuid) => `/file-manager/folders/download/${company_uuid}/${folder_uuid}`,

    newDownloadFolder: (company_uuid, folder_uuid) => `/file-manager/folders/new/download/${company_uuid}/${folder_uuid}`,

    filesBulkDownload: (company_uuid, file_process_manage_uuid) => `/file-manager/files/bulk-download/status/${company_uuid}/${file_process_manage_uuid}`,

    deleteFile: (company_uuid, file_uuid) => `/file-manager/files/delete/${company_uuid}/${file_uuid}`,

    deleteFolder: (company_uuid, folder_uuid) => `/file-manager/folders/delete/${company_uuid}/${folder_uuid}`,

    downloadMultiFiles: (company_uuid) => `/file-manager/files/download/multi/raw/${company_uuid}`,

    registerFolder: (company_uuid) => `/file-manager/folders/${company_uuid}`,

    registerFile: (company_uuid) => `/file-manager/files/${company_uuid}`,

    createFile: (company_uuid) => `/file-manager/files/raw/${company_uuid}`,

    createPhoto: (company_uuid) => `/takumipad-manager/photo/${company_uuid}`,

    chkTampering: (company_uuid, file_uuid) => `/takumipad-manager/photo/check-tampering/${company_uuid}/${file_uuid}`,

    stepUpdatePhoto: (company_uuid, file_uuid) => `/takumipad-manager/photo/update-content/${company_uuid}/${file_uuid}`,

    changeFolderName: (company_uuid, folder_uuid) => `/file-manager/folders/${company_uuid}/${folder_uuid}`,

    changeFileName: (company_uuid, file_uuid) => `/file-manager/files/${company_uuid}/${file_uuid}`,

    deleteBukkenFile: (company_uuid, file_uuid, bukken_uuid) => `bukken-manager/bukken-file-manager/files/delete/${company_uuid}/${file_uuid}/${bukken_uuid}`,

    deleteBukkenFolder: (company_uuid, folder_uuid, bukken_uuid) => `bukken-manager/bukken-file-manager/folders/delete/${company_uuid}/${folder_uuid}/${bukken_uuid}`,

    deleteBukkenPhoto: (company_uuid, folder_uuid, bukken_uuid) => `bukken-manager/bukken-file-manager/photo/delete/${company_uuid}/${folder_uuid}/${bukken_uuid}`,

    deleteMstFile: (company_uuid, file_uuid) => `bukken-manager/bukken-file-manager/files-mst/delete/${company_uuid}/${file_uuid}`,

    deleteMstFolder: (company_uuid, folder_uuid) => `bukken-manager/bukken-file-manager/folders-mst/delete/${company_uuid}/${folder_uuid}`,

    getMaxSizeUploadFile: (company_uuid) => `andescloud/env/${company_uuid}/list`,

    search: (company_uuid) => `file-manager/folders/deep-search/${company_uuid}`,

    blackboardMst: () => "/takumipad-manager/master/blackboard/search",

    blackboardList: (company_uuid) => `/takumipad-manager/blackboard/search/${company_uuid}`,

    blackboardPhotoList: (company_uuid) => `/takumipad-manager/photo/search/${company_uuid}`,

    blackboardEdit: (company_uuid, file_blackboard_uuid) => `/takumipad-manager/blackboard/edit/${company_uuid}/${file_blackboard_uuid}`,

    blackboardDelete: (company_uuid, file_blackboard_uuid) => `/takumipad-manager/blackboard/delete/${company_uuid}/${file_blackboard_uuid}`,

    blackboardDeleteMultiple: (company_uuid) => `/takumipad-manager/blackboard/delete/multi/${company_uuid}`,

    blackboardCandidateSearch: (company_uuid) => `/takumipad-manager/blackboard/candidate/search/${company_uuid}`,

    blackboardCandidateCreate: (company_uuid) => `/takumipad-manager/blackboard/candidate/${company_uuid}`,

    blackboardCandidateEdit: (company_uuid, candidate_uuid) => `/takumipad-manager/blackboard/candidate/edit/${company_uuid}/${candidate_uuid}`,

    blackboardCandidateDelete: (company_uuid, candidate_uuid) => `/takumipad-manager/blackboard/candidate/delete/${company_uuid}/${candidate_uuid}`,

    blackboardCreate: (company_uuid) => `/takumipad-manager/blackboard/${company_uuid}`,

    blackboardCreateFile: (company_uuid, file_blackboard_uuid) => `/takumipad-manager/blackboard/drawing/editimage/${company_uuid}/${file_blackboard_uuid}`,

    blackboardInfo: (company_uuid) => `/takumipad-manager/blackboard/search-blackboard/${company_uuid}`,

    blackboardEditInfo: (company_uuid, file_blackboard_uuid) => `/takumipad-manager/blackboard/${company_uuid}/${file_blackboard_uuid}`,

    blackboardGetDrawing: (company_uuid, file_blackboard_uuid) => `/takumipad-manager/blackboard/drawing/get/${company_uuid}/${file_blackboard_uuid}`,

    deleteCommonFile: (company_uuid, file_uuid) => `/bukken-manager/bukken-common-folder/file/delete/${company_uuid}/${file_uuid}`,

    deleteCommonFolder: (company_uuid, folder_uuid) => `/bukken-manager/bukken-common-folder/folder/delete/${company_uuid}/${folder_uuid}`,
  },
  bukken: {
    // 物件を登録する
    post: (company_uuid) => `/bukken-manager/bukken/${company_uuid}`,
    // 物件を論理削除する
    delete: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/delete/${company_uuid}/${bukken_uuid}`,
    // 物件を編集する
    edit: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/edit/${company_uuid}/${bukken_uuid}`,
    // 物件を完全削除する
    deletePermanent: (company_uuid, bukken_uuid) =>
      `/bukken-manager/bukken/delete-permanent/${company_uuid}/${bukken_uuid}`,
    // 物件を検索する
    search: (company_uuid) => `/bukken-manager/bukken/search/${company_uuid}`,
    searchAdvanced: (company_uuid) => `/bukken-manager/bukken/search/advance/${company_uuid}`,
    // 参加物件を検索する
    searchMemberIncluded: () => `/bukken-manager/bukken/search/member-included`,
    // 物件情報を取得する
    info: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/info/${company_uuid}/${bukken_uuid}`,
    // 物件情報を出力する
    outputInfo: (company_uuid) => `bukken-manager/bukken/info/output/${company_uuid}`,
    // 関連物件情報を取得する
    relatedInfo: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/related_info/${company_uuid}/${bukken_uuid}`,
    // bukken-folders -> bukken-folders/search/${company_uuid}/${bukken_uuid}
    searchFolders: (company_uuid, bukken_uuid) =>
      `/bukken-manager/bukken-folders/search/${company_uuid}/${bukken_uuid}`,

    rebuild: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/rebuild/${company_uuid}/${bukken_uuid}`,

    dublicate: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/duplicate/${company_uuid}/${bukken_uuid}`,

    pin: (company_uuid) => `/pinned/${company_uuid}`,
    unPin: (company_uuid) => `/pinned/delete/${company_uuid}`,
    // 参加者権限一覧を取得する
    authorityList: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/authority/list/${company_uuid}/${bukken_uuid}`,
    // 物件の参加者情報を取得する
    memberList: (company_uuid, bukken_uuid) => `/bukken-manager/bukken/member/list/${company_uuid}/${bukken_uuid}`,
  },
  // 機能権限
  featureAuthority: {
    // 機能権限を登録・更新する
    update: (company_uuid) => `/company-manager/authority/feature-authority/${company_uuid}`,
    // 物件（category=BUKKEN）の機能個別権限を user+target 指定で削除する（個別設定のリセット）
    bukkenDelete: (company_uuid) => `/company-manager/authority/feature-authority/delete/bukken/${company_uuid}`,
    // ファイル権限を検索する
    fileSearch: (company_uuid) => `/file-manager/authority/files/search/${company_uuid}`,
    // フォルダ権限を検索する
    folderSearch: (company_uuid) => `/file-manager/authority/folders/search/${company_uuid}`,
    // ファイル権限を登録・更新する
    fileUpdate: (company_uuid, file_uuid) => `/file-manager/authority/files/${company_uuid}/${file_uuid}`,
    // フォルダ権限を登録・更新する
    folderUpdate: (company_uuid, folder_uuid) => `/file-manager/authority/folders/${company_uuid}/${folder_uuid}`,
    // ファイル権限を削除する
    fileDelete: (company_uuid, file_uuid) => `/file-manager/authority/files/delete/${company_uuid}/${file_uuid}`,
    // フォルダ権限を削除する
    folderDelete: (company_uuid, folder_uuid) => `/file-manager/authority/folders/delete/${company_uuid}/${folder_uuid}`,
  },
  //
  bukkenDispItem: {
    // 物件一覧表示項目を編集する
    edit: (company_uuid) => `/bukken-manager/bukken-disp-item/edit/${company_uuid}`,
    // 物件一覧表示項目を取得する
    info: (company_uuid) => `/bukken-manager/bukken-disp-item/info/${company_uuid}`
  },
  //
  bukkenSearch: {
    // 物件検索条件を編集する
    post: (company_uuid) => `/bukken-manager/bukken-search/${company_uuid}`,
    edit: (company_uuid, search_pattern_uuid) =>
      `/bukken-manager/bukken-search/edit/${company_uuid}/${search_pattern_uuid}`,
    // 物件検索条件を取得する
    info: (company_uuid) => `/bukken-manager/bukken-search/info/${company_uuid}`,
    delete_permanent: (company_uuid, search_pattern_uuid) =>
      `/bukken-manager/bukken-search/delete-permanent/${company_uuid}/${search_pattern_uuid}`,
    filter_setting_item: (company_uuid) => `/bukken-manager/bukken-search/filter-setting-item/${company_uuid}`,
    change_setting_item: (company_uuid) => `/bukken-manager/bukken-search/filter-setting/${company_uuid}`,
    filter_pattern: (company_uuid) => `/bukken-manager/bukken-search/filter-pattern/${company_uuid}`,
    filter_search_edit: (company_uuid) => `/bukken-manager/bukken-search/filter-search-edit/${company_uuid}`,
  },
  //
  bukkenClassMst: {
    // 物件区分マスタを登録する
    post: (company_uuid) => `/bukken-manager/bukken-class-mst/${company_uuid}`,
    // 物件区分マスタを論理削除する
    delete: (company_uuid, bukken_class_uuid) =>
      `/bukken-manager/bukken-class-mst/delete/${company_uuid}/${bukken_class_uuid}`,
    // 物件区分マスタを編集する
    edit: (company_uuid, bukken_class_uuid) =>
      `/bukken-manager/bukken-class-mst/edit/${company_uuid}/${bukken_class_uuid}`,
    // 物件区分マスタに紐づくタブ情報と項目情報を取得する
    info: (company_uuid, bukken_class_uuid) =>
      `/bukken-manager/bukken-class-mst/info/${company_uuid}/${bukken_class_uuid}`,
    // 物件区分マスタのリストを取得する
    all: (company_uuid) => `/bukken-manager/bukken-class-mst/all/${company_uuid}`
  },
  //
  bukkenTabMst: {
    // 物件タブマスタを登録する
    post: (company_uuid) => `/bukken-manager/bukken-tab-mst/${company_uuid}`,
    // 物件タブマスタを論理削除する
    delete: (company_uuid, bukken_tab_uuid) =>
      `/bukken-manager/bukken-tab-mst/delete/${company_uuid}/${bukken_tab_uuid}`,
    // 物件タブマスタを編集する
    edit: (company_uuid, bukken_tab_uuid) => `/bukken-manager/bukken-tab-mst/edit/${company_uuid}/${bukken_tab_uuid}`,
    // 物件タブマスタ情報を取得する
    info: (company_uuid, bukken_tab_uuid) => `/bukken-manager/bukken-tab-mst/info/${company_uuid}/${bukken_tab_uuid}`,
    // 物件タブマスタリストを取得する
    all: (company_uuid) => `/bukken-manager/bukken-tab-mst/all/${company_uuid}`,
    //
    editList: (company_uuid, bukken_class_uuid) =>
      `/bukken-manager/class-tab-list/edit/${company_uuid}/${bukken_class_uuid}`
  },
  //
  classTabList: {
    // 区分ごとのタブリストマスタを編集する
    edit: (company_uuid, bukken_class_uuid) => `/class-tab-list/edit/${company_uuid}/${bukken_class_uuid}`
  },
  //
  bukkenItemMst: {
    // 物件項目マスタを登録する
    post: (company_uuid, bukken_tab_uuid) => `/bukken-manager/bukken-item-mst/${company_uuid}/${bukken_tab_uuid}`,
    // 物件項目マスタを論理削除する
    delete: (company_uuid, bukken_item_uuid) =>
      `/bukken-manager/bukken-item-mst/delete/${company_uuid}/${bukken_item_uuid}`,
    // 物件項目マスタを編集する
    edit: (company_uuid, bukken_item_uuid) => `/bukken-manager/bukken-item-mst/edit/${company_uuid}`,
    // 物件項目マスタを取得する
    get: (company_uuid, bukken_item_uuid) => `/bukken-manager/bukken-item-mst/get/${company_uuid}/${bukken_item_uuid}`,
    search: (company_uuid) => `/bukken-manager/bukken-item-mst/search/${company_uuid}`
  },
  bukkenItemListMst: {
    // 物件項目リストマスタを登録する
    post: (company_uuid, bukken_item_uuid) => `/bukken-manager/bukken-item-list-mst/${company_uuid}/${bukken_item_uuid}`,
    // 物件項目リストマスタを論理削除する
    delete: (company_uuid, bukken_item_uuid, bukken_item_list_uuid) =>
      `/bukken-manager/bukken-item-list-mst/delete/${company_uuid}/${bukken_item_uuid}/${bukken_item_list_uuid}`,
    // 物件項目リストマスタを編集する
    edit: (company_uuid, bukken_item_uuid, bukken_item_list_uuid) =>
      `/bukken-manager/bukken-item-list-mst/edit/${company_uuid}/${bukken_item_uuid}/${bukken_item_list_uuid}`,
    // 物件項目リストマスタを編集する
    get: (company_uuid, bukken_item_uuid) =>
      `/bukken-manager/bukken-item-list-mst/get-list/${company_uuid}/${bukken_item_uuid}`,
  },
  //
  bukkenTemplateMst: {
    // 物件テンプレートマスタを登録する
    post: (company_uuid) => `/bukken-manager/bukken-template-mst/${company_uuid}`,
    // 物件テンプレートマスタを論理削除する
    delete: (company_uuid, bukken_template_uuid) =>
      `/bukken-manager/bukken-template-mst/delete/${company_uuid}/${bukken_template_uuid}`,
    // 物件テンプレートマスタを編集する
    edit: (company_uuid, bukken_template_uuid) =>
      `/bukken-manager/bukken-template-mst/edit/${company_uuid}/${bukken_template_uuid}`,
    // 物件テンプレートマスタを完全削除する
    deletePermanent: (company_uuid, bukken_template_uuid) =>
      `/bukken-manager/bukken-template-mst/delete-permanent/${company_uuid}/${bukken_template_uuid}`,
    // 物件テンプレートマスタを取得する
    get: (company_uuid) => `/bukken-manager/bukken-template-mst/get/${company_uuid}`
  },
  //
  bukkenCommonFolder: {
    // 物件区分共通フォルダを取得する
    search: (company_uuid) => `/bukken-manager/bukken-common-folder/search/${company_uuid}`
  },
  //
  constTypeMst: {
    // 工種マスタを登録する
    post: (company_uuid) => `/bukken-manager/const-type-mst/${company_uuid}`,
    // 工種マスタを論理削除する
    delete: (company_uuid, const_type_uuid) =>
      `/bukken-manager/const-type-mst/delete/${company_uuid}/${const_type_uuid}`,
    // 工種マスタを編集する
    edit: (company_uuid, const_type_uuid) => `/bukken-manager/const-type-mst/edit/${company_uuid}/${const_type_uuid}`,
    // 工種マスタ一覧を取得する
    all: (company_uuid, bukken_class_uuid) => `/bukken-manager/const-type-mst/all/${company_uuid}/${bukken_class_uuid}`
  },
  //
  locationMst: {
    // 地域マスタを登録する
    post: (company_uuid) => `/bukken-manager/location-mst/${company_uuid}`,
    // 地域マスタを論理削除する
    delete: (company_uuid, location_uuid) => `/bukken-manager/location-mst/delete/${company_uuid}/${location_uuid}`,
    // 地域マスタを編集する
    edit: (company_uuid, location_uuid) => `/bukken-manager/location-mst/edit/${company_uuid}/${location_uuid}`,
    // 地域マスタ一覧を取得する
    all: (company_uuid) => `/bukken-manager/location-mst/all/${company_uuid}`
  },
  //
  bukkenPhotoFolders: {
    // 物件写真フォルダを登録する
    registerImageFolder: (company_uuid, bukken_uuid) =>
      `/bukken-manager/bukken-photo-folders/${company_uuid}/${bukken_uuid}`,

    // 物件写真フォルダを編集する
    changeImageFolderName: (company_uuid, photo_folder_uuid) =>
      `/bukken-manager/bukken-photo-folders/edit/${company_uuid}/${photo_folder_uuid}`,

    // 物件写真フォルダ情報を取得する
    info: (company_uuid, photo_folder_uuid) =>
      `/bukken-manager/bukken-photo-folders/children/photo/info/${company_uuid}/${photo_folder_uuid}`,
    // 物件写真フォルダを検索する
    search: (company_uuid) => `/bukken-manager/bukken-photo-folders/search/${company_uuid}`,
    // delete
    delete: (company_uuid, folder_uuid) => `/bukken-manager/bukken-photo-folders/delete/${company_uuid}/${folder_uuid}`
  },
  customer: {
    search: (company_uuid) => `/company-manager/customer/search/${company_uuid}`
  },
  department: {
    search: (company_uuid) => `/company-manager/department/info/${company_uuid}`
  },
  employee: {
    search: (company_uuid) => `/company-manager/employee/search/${company_uuid}`
  },
  customerGroup: {
    search: (company_uuid) => `/company-manager/customer-group/search/${company_uuid}`
  },
  customerEmployee: {
    search: (company_uuid, customer_uuid) => `/company-manager/customer-employee/search/${company_uuid}/${customer_uuid}`,
    list: (company_uuid) => `/company-manager/customer-employee/list/${company_uuid}`
  },

  customerEmployeeFromUser: {
    get: (company_uuid, customer_uuid) => `/company-manager/employee/get-from-user/${company_uuid}/${customer_uuid}`
  },

  quotation: {
    // 見積書登録
    post: (company_uuid) => `/quotation-manager/quotation/${company_uuid}`,
    // 見積書情報取得
    get: (company_uuid, quotation_uuid) => `/quotation-manager/quotation/${company_uuid}/${quotation_uuid}`,
    // 見積書編集
    edit: (company_uuid, quotation_uuid) => `/quotation-manager/quotation/edit/${company_uuid}/${quotation_uuid}`,
    // 見積書一覧取得
    list: (company_uuid, bukken_uuid) => `/quotation-manager/quotation/list/${company_uuid}/${bukken_uuid}`,
    // 見積書論理削除
    delete: (company_uuid) => `/quotation-manager/quotation/delete/${company_uuid}`,
    // 見積書発行
    issue: (company_uuid, quotation_uuid) => `/quotation-manager/quotation/issue/${company_uuid}/${quotation_uuid}`,
    // 見積作成用マスタ情報取得
    mst: () => "/quotation-manager/quotation/mst",
    // 明細マスタ項目作成
    item: (company_uuid) => `/quotation-manager/quotation/item/${company_uuid}`,
    // 明細マスタ項目更新
    itemEdit: (company_uuid, mst_quotation_item_uuid) =>
      `/quotation-manager/quotation/item/edit/${company_uuid}/${mst_quotation_item_uuid}`,
    // 明細マスタ一覧取得
    itemList: (company_uuid) => `/quotation-manager/quotation/item/list/${company_uuid}`,
    // 明細マスタ項目の論理削除
    itemDelete: (company_uuid) => `/quotation-manager/quotation/item/delete/${company_uuid}`,

    importCsv: (company_uuid) => `/quotation-manager/quotation/import/item/${company_uuid}`,

    lastInput: (company_uuid) => `/quotation-manager/quotation/last-input/${company_uuid}`,

    // 提出先に対応する税設定情報取得
    lastSetting: (company_uuid, customerUuid) => `/quotation-manager/quotation/last-setting/${company_uuid}/${customerUuid}`,

    // テンプレートに対応する前回利用座標取得
    lastPosition: (company_uuid, templateUuid) => `/quotation-manager/quotation/last-position/${company_uuid}/${templateUuid}`,

    searchAdvanced: (company_uuid) => `/quotation-manager/quotation/search/advance/${company_uuid}`,

    download: (company_uuid) => `/quotation-manager/quotation/download/${company_uuid}`
  },

  invoice: {
    // 請求書作成
    post: (company_uuid, bukken_uuid) => `/invoice-manager/invoice/${company_uuid}`,
    // 請求書取得
    get: (company_uuid, invoice_uuid) => `/invoice-manager/invoice/${company_uuid}/${invoice_uuid}`,
    // 請求書更新
    edit: (company_uuid, invoice_uuid) => `/invoice-manager/invoice/edit/${company_uuid}/${invoice_uuid}`,
    // 請求書一覧取得
    list: (company_uuid, bukken_uuid) => `/invoice-manager/invoice/list/${company_uuid}/${bukken_uuid}`,
    // 請求書の論理削除
    delete: (company_uuid) => `/invoice-manager/invoice/delete/${company_uuid}`,
    // 請求書発行
    issue: (company_uuid, invoice_uuid) => `/invoice-manager/invoice/issue/${company_uuid}/${invoice_uuid}`,
    // 前回入力請求書データ取得
    lastInput: (company_uuid) => `/invoice-manager/invoice/last-input/${company_uuid}`,
    // 請求書作成に必要なマスタデータ取得
    mst: () => "/invoice-manager/invoice/mst",

    searchAdvanced: (company_uuid) => `/invoice-manager/invoice/search/advance/${company_uuid}`,
    //
    lastSetting: (company_uuid, customerUuid) => `/invoice-manager/invoice/last-setting/${company_uuid}/${customerUuid}`,

    // テンプレートに対応する前回利用座標取得
    lastPosition: (company_uuid, templateUuid) => `/invoice-manager/invoice/last-position/${company_uuid}/${templateUuid}`,

    download: (company_uuid) => `/invoice-manager/invoice/download/${company_uuid}`
  },

  // shashikanri api config
  shashiKanri: {
    // create photobook
    createPhotobook: (company_uuid) => `/photobook-manager/photobook/${company_uuid}`,
    // get data photobook
    getPhotobook: (company_uuid, photobook_uuid) => `/photobook-manager/photobook/${company_uuid}/${photobook_uuid}`,
    // edit photobook
    editPhotobook: (company_uuid, photobook_uuid) => `/photobook-manager/photobook/edit/${company_uuid}/${photobook_uuid}`,
    // get list photobook by bukken
    getPhotobookListByBukken: (company_uuid, bukken_uuid) => `/photobook-manager/photobook/list/${company_uuid}/${bukken_uuid}`,
    // delete logic photobook
    deletePhotobook: (company_uuid, photobook_uuid) => `/photobook-manager/photobook/delete/${company_uuid}/${photobook_uuid}`,
    // export photobook
    exportPhotobook: (company_uuid, photobook_uuid) => `/photobook-manager/photobook/export/${company_uuid}/${photobook_uuid}`,
    // get photobook by bukken
    getPhotosInMonth: (company_uuid, folder_uuid) => `/photobook-manager/photobook/photos/${company_uuid}/${folder_uuid}`,
    // photo check
    photoCheck: (company_uuid, folder_uuid) => `/photobook-manager/photobook/photo-check/${company_uuid}/${folder_uuid}`,
    // get Photo Note
    getPhotoNote: (company_uuid, photobook_uuid, file_uuid) => `/photobook-manager/photobook/note/${company_uuid}/${photobook_uuid}?file_uuid=${file_uuid}`,
    // get template photobook
    getTemplate: (company_uuid, photobook_template_uuid) =>
      `/photobook-manager/photobook/template/${company_uuid}/${photobook_template_uuid}`,
    //get list template
    getListTemplate: (company_uuid) => `/photobook-manager/photobook/template/list/${company_uuid}`,
    // create duplicate photobook
    duplicatePhotobook: (company_uuid, photobook_uuid) =>
      `/photobook-manager/photobook/duplicate/${company_uuid}/${photobook_uuid}`
  },
  sharedStorage: {
    syncFolderChildren: (company_uuid) => `/file-manager/sync/folders/children/${company_uuid}`,
    syncPermission: (company_uuid, folder_uuid) => `/file-manager/sync/permission/${company_uuid}/${folder_uuid}`,
  },

  bulletin: {
    create: (company_uuid) => `/bulletin-manager/bulletin/post/${company_uuid}`,
    edit: (company_uuid, post_uuid) => `/bulletin-manager/bulletin/post/edit/${company_uuid}/${post_uuid}`,
    get: (company_uuid, post_uuid) => `/bulletin-manager/bulletin/post/${company_uuid}/${post_uuid}`,
    delete: (company_uuid, post_uuid) => `/bulletin-manager/bulletin/post/delete/${company_uuid}/${post_uuid}`,
    search: (company_uuid) => `/bulletin-manager/bulletin/post/search/${company_uuid}`,
    createCategory: (company_uuid) => `/bulletin-manager/bulletin/category/${company_uuid}`,
    deleteCategory: (company_uuid, category_uuid) => `/bulletin-manager/bulletin/category/delete/${company_uuid}/${category_uuid}`,
    addFavorite: (company_uuid) => `/bulletin-manager/bulletin/post/favorite/${company_uuid}`,
    addRead: (company_uuid) => `/bulletin-manager/bulletin/post/reader/${company_uuid}`,
    getListRead: (company_uuid, post_uuid) => `/bulletin-manager/bulletin/post/reader/list/${company_uuid}/${post_uuid}`
  },

  document: {
    create: (company_uuid) => `/document-manager/document/${company_uuid}`,
    edit: (company_uuid, document_uuid) => `/document-manager/document/edit/${company_uuid}/${document_uuid}`,
    get: (company_uuid, document_uuid) => `/document-manager/document/${company_uuid}/${document_uuid}`,
    delete: (company_uuid, document_uuid) => `/document-manager/document/delete/${company_uuid}/${document_uuid}`,
    search: (company_uuid) => `/document-manager/document/search/${company_uuid}`,
    getCategories: (company_uuid) => `/document-manager/document/category/${company_uuid}`,
    createCategory: (company_uuid) => `/document-manager/document/category/${company_uuid}`,
    deleteCategory: (company_uuid, category_uuid) => `/document-manager/document/category/delete/${company_uuid}/${category_uuid}`,
  },

  newsPortal: {
    getSettingNews: (company_uuid) => `/file-manager/env/info/${company_uuid}`,
    setSettingNews: (company_uuid) => `/file-manager/env/${company_uuid}`,
    getListPost: (company_uuid) => `/bulletin-manager/bulletin/post/portal/${company_uuid}`
  },

  localConfigManager: {
    getAtfStatus: (location_uuid) => `/local-config-manager/localconfig/atf/status/${location_uuid}`,
  },

  importMaster: (company_uuid) => `/company-manager/master/import/${company_uuid}`,
  downloadTemplate: (company_uuid) => `/company-manager/master/download/template/${company_uuid}`,

  adminDashboard: {
    contractCount: "/user-manager/admin-dashboard/companies/contract/count",
    optionInfo: "/user-manager/admin-dashboard/option-info",
    countAll: "/user-manager/admin-dashboard/count-all",
    getCountAll: "/user-manager/admin-dashboard/get-countall",
    accessMonthly: "/user-manager/admin-dashboard/access/monthly",
    accessDaily: "/user-manager/admin-dashboard/access/daily",
    accessCompany: "/user-manager/admin-dashboard/access/company",
    localConf: "/user-manager/admin-dashboard/local-conf",
    localConfDetail: (location_uuid) => `/user-manager/admin-dashboard/local-conf/${location_uuid}`
  },

  whiteboard: {
    searchBukkenView: (company_uuid) => `/whiteboard/assignment/bukken-view/search/${company_uuid}`,
    searchSagyoView: (company_uuid) => `/whiteboard/assignment/sagyo-view/search/${company_uuid}`,
    createAssignment: (company_uuid) => `/whiteboard/assignment/multi-create/${company_uuid}`,
    getAssignment: (company_uuid, assignment_uuid) => `/whiteboard/assignment/${company_uuid}/${assignment_uuid}`,
    editAssignment: (company_uuid, assignment_uuid) => `/whiteboard/assignment/edit/${company_uuid}/${assignment_uuid}`,
    deleteAssignment: (company_uuid, assignment_uuid) =>
      `/whiteboard/assignment/delete/${company_uuid}/${assignment_uuid}`,
    checkDuplicatedAssignment: (company_uuid) => `/whiteboard/assignment/check-duplicated/${company_uuid}`,
    employeeSearch: (company_uuid) => `/whiteboard/employee/search/${company_uuid}`,
    customerEmployeeSearch: (company_uuid) => `/whiteboard/customer-employee/search/${company_uuid}`
  }
};

export default API_CONFIG;
